import { Environment } from "@bbnpm/bb-analytics";

/**
 * Matomo Configuration
 */
export const MATOMO_TIERS_CONFIG = {
  DEV: { siteId: 160, environment: Environment.DEV },
  ALPHA: { siteId: 169, environment: Environment.ALPHA },
  PROD: { siteId: 182, environment: Environment.PROD },
} as const;

/**
 * Custom Dimensions Configuration
 * These dimension IDs must match what's configured in your Matomo instance
 * The keys are the dimension names, values are the Matomo dimension IDs
 */
export const CUSTOM_DIMENSIONS = {
  userCustomDimensionsMap: {
    // Custom dimension names mapped to their Matomo IDs
    "Full Name": 11,
    "Auth Source": 12,
    "Upload Folder": 13,
  },
};

export const EVENTS_LABELS = ["category", "action", "name", "value"];

export type EventObject = "category" | "action" | "name" | "value";

/**
 * Maps dimension IDs back to their names for debugging
 */
export const DIMENSION_MAP = {
  11: "Full Name",
  12: "Auth Source",
  13: "Upload Folder",
} as const;
